@if (!isMobile && !transparent) {
  <div
    role="banner"
    class="flex__center nav-wrapper"
  [ngStyle]="{
    background: transparent
      ? 'transparent'
      : 'linear-gradient(to left top, #0D4557, #001241)'
  }"
    >
    <div class="flex__row--space-between nav_content">
      @if (activeRoute !== 'linkedin-login') {
        <div class="logo">
          <img
            class="pipa"
            src="assets/images/pipa-white.png"
            draggable="false"
            alt="pipa"
            />
        </div>
      }
      @if (!transparent && hasRawConnections) {
        <div class="nav-wrapper__search">
          <app-debouce-search-input
            [theme]="'dark'"
            [placeholder]="'Search leads and connections...'"
            [searchMethod]="searchConnections"
            style="width: 325px; padding: 0"
        [displayConfig]="{
          imageProperty: 'image_url',
          defaultPrimaryText: 'lead_name',
          primaryText: 'connection_name',
          secondaryText: 'job_title',
          secondLineText: 'location'
        }"
            (selection)="handleSelection($event)"
          ></app-debouce-search-input>
        </div>
      }
      <div class="flex__center">
        @if (!transparent) {
          <app-verify-phone></app-verify-phone>
        }
        @if (!transparent) {
          <app-account-menu
            [user]="user"
            [userName]="userName"
          ></app-account-menu>
        }
      </div>
    </div>
  </div>
}
